module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/light/long-down-61b1489336600e8f682317858fbf972d.png";